import { render, staticRenderFns } from "./aiSearchList.vue?vue&type=template&id=66e13994&scoped=true"
import script from "./aiSearchList.vue?vue&type=script&lang=ts"
export * from "./aiSearchList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e13994",
  null
  
)

export default component.exports